import sortBy from 'lodash/sortBy'
import Strategy from '../entities/strategy'
import { map } from '../update'
import { isStrategyVisible } from '../config/visible'
import { getStrategyCategoryOrder, getStrategyOrder } from '../config/order'
import { getStrategies, getStrategySeries } from '../actions/strategies'

const StrategiesStore = {
  getInitialState() {
    return []
  },

  reset(_, strategies) {
    // configuration determines visibility regardless of data
    let visible = (strategies = strategies.filter(isStrategyVisible))

    // sort strategies by configuration: region, then category,
    // then by index invcategoryList strategies array for the region
    let sorted = sortBy(visible, [
      'Region',
      getStrategyCategoryOrder,
      getStrategyOrder
    ])

    return sorted.map(item => new Strategy(item))
  },

  addSeries(strategies, dataPoints) {
    const ID = Number(dataPoints[0].ID)

    return map(strategies, function(strategy) {
      if (strategy.ID === ID) {
        return strategy.update({ dataPoints })
      }

      return strategy
    })
  },

  setLoading(strategies, id) {
    return map(strategies, function(strategy) {
      if (strategy.ID === id) {
        return strategy.update({ loading: true })
      }

      return strategy
    })
  },

  register() {
    return {
      [getStrategies.done]: this.reset,
      [getStrategySeries.done]: this.addSeries,
      [getStrategySeries.open]: this.setLoading
    }
  },

  deserialize(strategies) {
    return this.reset(null, strategies || [])
  }
}

export default StrategiesStore



// WEBPACK FOOTER //
// ./src/domains/strategies.js